module.exports = __webpack_public_path__ + "img/car.3d25e057.jpg";